import sendGtmEvent from "./sendGtmEvent";

export const GA_GTM_EVENT_NAMES = {
  CATEGORY_BANNERS: "banery_w_kategoriach",
  CATEGORY_CLICK: "klikniecia_w_kategorie",
  CATEGORY_EXPAND: "nawigacja_rozwiniecie_kategorii",
  CATEGORY_COLLAPSE: "nawigacja_zwiniecie_kategorii",
} as const;

export const GA_GTM_CATEGORY_CLICK_ACTIONS = {
  HEADER: "Header",
  SIDEBAR: "Pasek boczny",
  MOBILE: "Mobile",
} as const;

export const GA_GTM_NAVIGATION = {
  CATEGORY: "Nawigacja",
  EXPAND_ACTION: "Rozwinięcie kategorii",
  COLLAPSE_ACTION: "Zwinięcie kategorii",
} as const;

interface ISendGaGtmEventArgs {
  gtmEventName: string;
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
}

const sendGaGtmEvent = ({
  gtmEventName,
  eventCategory,
  eventAction,
  eventLabel,
}: ISendGaGtmEventArgs) => {
  sendGtmEvent("GAevent", {
    gtm_event_name: gtmEventName,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue: 0,
    eventNonInteraction: true,
  });
};

export default sendGaGtmEvent;
